module.exports = __webpack_public_path__ + "static/img/4.665877f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/4.png
// module id = QoAH
// module chunks = 0